import { useEffect, useState } from 'react';
import { api } from '../core/apiClient';

export interface CompositeCodeOption {
  id: number;
  code: string;
  name: string;
  isActive: number;
  brandName?: string | null;
}

/**
 * "Tipus de producte" (catàleg de Compres: composite_codes). Font única per als desplegables de
 * Licitacions, Expedients Comercials i la configuració de criteris.
 */
export function useCompositeCodes() {
  const [items, setItems] = useState<CompositeCodeOption[]>([]);

  useEffect(() => {
    let alive = true;
    api
      .get<{ success: boolean; data: CompositeCodeOption[] }>('/catalog/composite-codes')
      .then((res) => {
        if (alive) setItems(res.data ?? []);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  /** Opcions d'un desplegable: els actius, més el valor actual encara que estigui desactivat. */
  const optionsFor = (current?: string | number | null) =>
    items.filter((c) => c.isActive || (current != null && current !== '' && String(c.id) === String(current)));

  const nameOf = (id?: number | string | null): string | null => {
    if (id == null || id === '') return null;
    return items.find((c) => String(c.id) === String(id))?.name ?? null;
  };

  return { items, active: items.filter((c) => c.isActive), optionsFor, nameOf };
}

export const compositeCodeLabel = (c: Pick<CompositeCodeOption, 'code' | 'name'>) => `${c.code} - ${c.name}`;
